/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { CreateReservationPayload } from 'api/actions/create-reservation/create-reservation-payload';
import { CreateReservationPathParameters } from 'api/actions/create-reservation/create-reservation-path-parameters';
import { CreateReservationResponse } from 'api/actions/create-reservation/create-reservation-response';

type CreateReservationQueryParameters = Record<string, any>;

/**
 * The path of the CreateReservation action.
 */
export const createReservationActionPath = new SweetPath<keyof CreateReservationPathParameters>('/reservations', {
  path: '{param}',
});

/**
 * Creates a contextualized CreateReservation actions.
 */
export default function createCreateReservationAction(axios: AxiosInstance) {
  return function createReservationAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: CreateReservationQueryParameters;
    payload: CreateReservationPayload;
  }) {
    const path = createReservationActionPath.original;

    return axios.post<CreateReservationResponse, CreateReservationResponse, CreateReservationPayload>(path, payload);
  };
}
